/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/arrRemove */
function o(e,n){if(e){let i=e.indexOf(n);0<=i&&e.splice(i,1)}}export{o as arrRemove};
//# sourceMappingURL=arrRemove.mjs.map